export default "__VITE_ASSET__aa39c5a6__"